import ControlledRadioGroupField from 'views/components/common/Form/ReactForm/ControlledRadioGroupField/ControlledRadioGroupField';

export default ControlledRadioGroupField;
